interface CustomShadowOptions {
  filter: string;
  boxShadow: string;
}

declare module '@mui/material/styles' {
  interface Theme {
    customShadows: CustomShadowOptions;
  }
  interface ThemeOptions {
    customShadows: CustomShadowOptions;
  }
}

export const customShadows: CustomShadowOptions = {
  filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.06))',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
};
